import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export const PageHeader = ({ title, subtitle, actions, backTo, backLabel }) => (
  <div className='wm-page-header'>
    <div className='wm-page-header__text'>
      {backTo && (
        <Link to={backTo} className='wm-page-header__back'>
          <ChevronLeft size={15} strokeWidth={2} />
          {backLabel}
        </Link>
      )}
      <h1 className='wm-page-header__title'>{title}</h1>
      {subtitle && <div className='wm-page-header__subtitle'>{subtitle}</div>}
    </div>
    {actions && <div className='wm-page-header__actions'>{actions}</div>}
  </div>
);
